import * as yup from 'yup';

export const validationSchema = yup.object().shape({
    password: yup.string().required('Password is required'),
    confirmPassword: yup
        .string()
        .required('Please confirm your password')
        .oneOf([yup.ref('password')], "Password doesn't match"),
});
